import React from "react";
import { NavLink, Link } from "react-router-dom";

const MenuItems = (props) => {
  const { parentMenu, secondParentMenu, activeMenu } = props;
  return (
    <React.Fragment>
      <li
        className={
          parentMenu === "about-us"
            ? "menu-item-has-children current-menu-item"
            : "menu-item-has-children"
        }
      >
        <Link to="" className={activeMenu === "" ? "active-menu" : ""}>
          About Us
        </Link>
        <ul className="sub-menu submenu">
          <div className="border_menu ">
            <div className="row">
              <div className="col-lg-4">
                <div className="main_menu_inner mega_menu_set">
                  {/* <h4>Microsoft Tech</h4> */}
                  <ul>
                    <li>
                      <NavLink
                        to="/company-overview"
                        lassName={
                          activeMenu === "/company-overview"
                            ? "active-menu"
                            : ""
                        }
                      >
                        Company Overview
                      </NavLink>{" "}
                    </li>

                    <li>
                      <NavLink
                        to="/group-companies"
                        lassName={activeMenu === "/" ? "active-menu" : ""}
                      >
                        Group Companies
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-lg-4">
                <div className="main_menu_inner mega_menu_set">
                  <ul>
                    <li>
                      <NavLink
                        to="/leadership"
                        lassName={activeMenu === "" ? "active-menu" : ""}
                      >
                        Leadership
                      </NavLink>{" "}
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-lg-4">
                <div className="main_menu_inner mega_menu_set">
                  <ul>
                    <li>
                      <NavLink
                        to="/global-presence"
                        lassName={
                          activeMenu === "/global-presence" ? "active-menu" : ""
                        }
                      >
                        Global Presence
                      </NavLink>{" "}
                    </li>
                  </ul>
                </div>
              </div>

              {/* <div className="col-lg-3">
                <div className="main_menu_inner mega_menu_set">
                  <h4>Resources</h4>
                  <ul>
                    <li>
                      <NavLink
                        to="/power-bi"
                        lassName={activeMenu === "/" ? "active-menu" : ""}
                      >
                        Power BI
                      </NavLink>{" "}
                    </li>

                    <li>
                      <NavLink
                        to="/tableau"
                        lassName={activeMenu === "" ? "active-menu" : ""}
                      >
                        <span>Tableau</span>
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        to="/database-management"
                        lassName={
                          activeMenu === "/Database-Management"
                            ? "active-menu"
                            : ""
                        }
                      >
                        Database Management
                      </NavLink>{" "}
                    </li>
                  
                  </ul>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="main_menu_inner mega_menu_set">
                  <h4>DeepTech</h4>
                  <ul>
                    <li>
                      <NavLink
                        to="/artificial-intelligence"
                        lassName={
                          activeMenu === "/Artificial-Intelligence"
                            ? "active-menu"
                            : ""
                        }
                      >
                        Artificial Intelligence (AI)
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        to="/machine-learning"
                        lassName={
                          activeMenu === "/Machine-Learning"
                            ? "active-menu"
                            : ""
                        }
                      >
                        Machine Learning
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        to="/data-science"
                        lassName={
                          activeMenu === "/Data-Science" ? "active-menu" : ""
                        }
                      >
                        Data Science
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        to="/blockchain"
                        lassName={
                          activeMenu === "/blockchain"
                            ? "active-menu"
                            : ""
                        }
                      >
                       BlockChain
                      </NavLink>{" "}
                    </li>
                  </ul>
                  <h4 className="pt-3">Digital Transformation</h4>
                  <ul>
                    <li>
                      <NavLink
                        to="/ux-ui-design"
                        lassName={
                          activeMenu === "/Ux-Ui-Design" ? "active-menu" : ""
                        }
                      >
                        UI/UX Design
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/digital-marketing"
                        lassName={
                          activeMenu === "/Digitle-Market" ? "active-menu" : ""
                        }
                      >
                        Digital Marketing
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        to="/quality-engineering"
                        lassName={
                          activeMenu === "/Quality-Engineering"
                            ? "active-menu"
                            : ""
                        }
                      >
                        Quality Engineering
                      </NavLink>{" "}
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="main_menu_inner">
                  <h4>Application Development</h4>
                  <ul>
                    <li>
                      <NavLink
                        to="/web-development"
                        lassName={
                          activeMenu === "/Web-Development" ? "active-menu" : ""
                        }
                      >
                        Web Development
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        to="/software-development"
                        lassName={
                          activeMenu === "/Software-Development"
                            ? "active-menu"
                            : ""
                        }
                      >
                        Software Development
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        to="/mobile-app-development"
                        lassName={
                          activeMenu === "/Mobile-App-Development"
                            ? "active-menu"
                            : ""
                        }
                      >
                        Mobile App Development
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        to="/cms-development"
                        lassName={
                          activeMenu === "/CMS-Development" ? "active-menu" : ""
                        }
                      >
                        CMS Development
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        to="/crm-development"
                        lassName={
                          activeMenu === "/CRM-Development" ? "active-menu" : ""
                        }
                      >
                        CRM Development
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        to="/ecommerce-development"
                        lassName={
                          activeMenu === "/eCommerce-development"
                            ? "active-menu"
                            : ""
                        }
                      >
                        e-commerce development
                      </NavLink>{" "}
                    </li>
                  </ul>
                </div>
              </div> */}
            </div>
          </div>
        </ul>
      </li>

      <li
        className={
          parentMenu === "solution"
            ? "menu-item-has-children current-menu-item"
            : "menu-item-has-children"
        }
      >
        <Link to="" className={activeMenu === "" ? "active-menu" : ""}>
          Services
        </Link>
        <ul className="sub-menu submenu">
          <div className="border_menu ">
            <div className="row">
              <div className="col-lg-4">
                <div className="main_menu_inner mega_menu_set">
                  {/* <h4>By Business Scales</h4> */}
                  <ul>
                    <li>
                      <NavLink
                        to="/AI-LLM-Solutions"
                        lassName={
                          activeMenu === "/AI-LLM-Solutions"
                            ? "active-menu"
                            : ""
                        }
                      >
                        AI & LLM Solutions
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        to="/salesforce-consulting"
                        lassName={
                          activeMenu === "/salesforce-consulting"
                            ? "active-menu"
                            : ""
                        }
                      >
                        Salesforce Consulting
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        to="/staff-augmentation"
                        lassName={
                          activeMenu === "/staff-augmentation"
                            ? "active-menu"
                            : ""
                        }
                      >
                        Staff Augmentation (Dedicated Teams)
                      </NavLink>{" "}
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="main_menu_inner mega_menu_set">
                  {/* <h4>By Business Scales</h4> */}
                  <ul>
                    <li>
                      <NavLink
                        to="/blockchain"
                        lassName={
                          activeMenu === "/blockchain" ? "active-menu" : ""
                        }
                      >
                        Blockchain Development
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        to="/web-mobile-app-development"
                        lassName={
                          activeMenu === "/web-mobile-app-development"
                            ? "active-menu"
                            : ""
                        }
                      >
                        Web & Mobile App Development
                      </NavLink>{" "}
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="main_menu_inner mega_menu_set">
                  {/* <h4>By Business Scales</h4> */}
                  <ul>
                    <li>
                      <NavLink
                        to="/fintech-app-engineering"
                        lassName={
                          activeMenu === "/fintech-app-engineering"
                            ? "active-menu"
                            : ""
                        }
                      >
                        Fintech Application Engineering
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        to="/cloud-devops"
                        lassName={
                          activeMenu === "/cloud-devops" ? "active-menu" : ""
                        }
                      >
                        Cloud & DevOps
                      </NavLink>{" "}
                    </li>
                  </ul>
                </div>
              </div>
              {/* <div className="col-lg-3">
                <div className="main_menu_inner mega_menu_set">
                  <h4>Custom Solutions</h4>
                  <ul>
                    <li>
                      <NavLink
                        to="/devops-solutions"
                        lassName={
                          activeMenu === "/Devops-Solutions"
                            ? "active-menu"
                            : ""
                        }
                      >
                        DevOps Solutions
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        to="/cloud-solutions"
                        lassName={
                          activeMenu === "/Cloud-Solutions" ? "active-menu" : ""
                        }
                      >
                        Cloud Solutions
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        to="/on-demand-business-solutions"
                        lassName={
                          activeMenu === "/On-Demand-Business-Solutions"
                            ? "active-menu"
                            : ""
                        }
                      >
                        On-demand Business Solutions
                      </NavLink>{" "}
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="main_menu_inner mega_menu_set">
                  <h4>Industry Expertise</h4>
                  <ul>
                    <li>
                      <NavLink
                        to="/business-app-solution"
                        lassName={
                          activeMenu === "/business-app-solution"
                            ? "active-menu"
                            : ""
                        }
                      >
                        Retail/Business{" "}
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        to="/fitness-wellness-app-solutions"
                        lassName={
                          activeMenu === "/fitness-wellness-app-solutions"
                            ? "active-menu"
                            : ""
                        }
                      >
                        Fitness App{" "}
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        to="/fintech-app-solution"
                        lassName={
                          activeMenu === "/fintech-app-solution"
                            ? "active-menu"
                            : ""
                        }
                      >
                        Fintech-App{" "}
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        to="/travel-app-solutions"
                        lassName={
                          activeMenu === "/travel-app-solutions"
                            ? "active-menu"
                            : ""
                        }
                      >
                        Travel Tourism
                      </NavLink>{" "}
                    </li>

                    <li>
                      <NavLink
                        to="/real-estate-app-solution"
                        lassName={
                          activeMenu === "/real-estate-app-solution"
                            ? "active-menu"
                            : ""
                        }
                      >
                        Real Estate{" "}
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        to="/healthcare-app-solution"
                        lassName={
                          activeMenu === "/healthcare-app-solution"
                            ? "active-menu"
                            : ""
                        }
                      >
                        Healthcare
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink to="./ecommerce-solutions">
                        e-commerce App
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="main_menu_inner">
                  <h4>Salesforce Development</h4>
                  <ul>
                    <li>
                      <NavLink
                        to="/salesforce-consulting-services"
                        lassName={
                          activeMenu === "/Salesforce-Consulting-Services"
                            ? "active-menu"
                            : ""
                        }
                      >
                        Salesforce Consulting
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        to="/salesforce-implementation"
                        lassName={
                          activeMenu === "/Salesforce-Implementation"
                            ? "active-menu"
                            : ""
                        }
                      >
                        Salesforce Implementation{" "}
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        to="/salesforce-lightning-services"
                        lassName={
                          activeMenu === "/Salesforce-Lightning-Services"
                            ? "active-menu"
                            : ""
                        }
                      >
                        Salesforce Lightning{" "}
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        to="/salesforce-exchange"
                        lassName={
                          activeMenu === "/Salesforce-Exchange"
                            ? "active-menu"
                            : ""
                        }
                      >
                        SalesForce App Exchange
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        to="/salescloud-consulting"
                        lassName={
                          activeMenu === "/SalesCloud-Consulting"
                            ? "active-menu"
                            : ""
                        }
                      >
                        Sales Cloud Consulting{" "}
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </div> */}
            </div>
          </div>
        </ul>
      </li>

      <li
        className={
          parentMenu === "products"
            ? "menu-item-has-children current-menu-item"
            : "menu-item-has-children"
        }
      >
        <Link to="" className={activeMenu === "" ? "active-menu" : ""}>
          Products
        </Link>
        <ul className="sub-menu submenu">
          <div className="border_menu ">
            <div className="row">
              <div className="col-lg-4">
                <div className="main_menu_inner mega_menu_set">
                  {/* <h4>By Business Scales</h4> */}
                  <ul>
                    <li>
                      <a
                        href="https://www.oviyaa.ai/"
                        target="_blank"
                        className={activeMenu === "" ? "active-menu" : ""}
                      >
                        Oviyaa
                      </a>
                    </li>

                    <li>
                      <NavLink
                        to=""
                        lassName={activeMenu === "" ? "active-menu" : ""}
                      >
                        <span className="coming-soon-link">Eaglient</span>
                      </NavLink>{" "}
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="main_menu_inner mega_menu_set">
                  {/* <h4>By Business Scales</h4> */}
                  <ul>
                    <li>
                      <NavLink
                        to=""
                        lassName={activeMenu === "" ? "active-menu" : ""}
                      >
                        <span className="coming-soon-link">Opteev</span>
                      </NavLink>{" "}
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="main_menu_inner mega_menu_set">
                  {/* <h4>By Business Scales</h4> */}
                  <ul>
                    <li>
                      <a
                        href="https://tradicorn.com/"
                        target="_blank"
                        className={activeMenu === "" ? "active-menu" : ""}
                      >
                        Tradicorn
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </ul>
      </li>

      <li
        className={
          parentMenu === "resources"
            ? "menu-item-has-children current-menu-item"
            : "menu-item-has-children"
        }
      >
        <Link to="" className={activeMenu === "" ? "active-menu" : ""}>
          Resources
        </Link>
        <ul className="sub-menu submenu">
          <div className="border_menu ">
            <div className="row">
              <div className="col-lg-4">
                <div className="main_menu_inner mega_menu_set">
                  {/* <h4>By Business Scales</h4> */}
                  <ul>
                    <li>
                      <NavLink
                        to="/case-study"
                        lassName={
                          activeMenu === "/case-study" ? "active-menu" : ""
                        }
                      >
                        Case Studies
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        to="/current-openings"
                        lassName={
                          activeMenu === "/current-openings"
                            ? "active-menu"
                            : ""
                        }
                      >
                        Careers
                      </NavLink>{" "}
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="main_menu_inner mega_menu_set">
                  {/* <h4>By Business Scales</h4> */}
                  <ul>
                    <li>
                      <NavLink
                        to="/blog"
                        lassName={activeMenu === "/blog" ? "active-menu" : ""}
                      >
                        Blogs
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        to="/contact-us"
                        lassName={
                          activeMenu === "/contact-us" ? "active-menu" : ""
                        }
                      >
                        Contact Us
                      </NavLink>{" "}
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="main_menu_inner mega_menu_set">
                  {/* <h4>By Business Scales</h4> */}
                  <ul>
                    <li>
                      <NavLink
                        to="/white-paper"
                        lassName={
                          activeMenu === "/white-paper" ? "active-menu" : ""
                        }
                      >
                        Whitepapers
                      </NavLink>{" "}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </ul>
      </li>

      {/* <li
        className={
          parentMenu === "hire-dedicated-developers"
            ? "menu-item-has-children current-menu-item"
            : "menu-item-has-children"
        }
      >
        <Link to="" className={activeMenu === "" ? "active-menu" : ""}>
          Hire offshore developers
        </Link>

        <ul className="sub-menu submenu">
          <div className="border_menu ">
            <div className="row">
              <div className="col-lg-3">
                <div className="main_menu_inner mega_menu_set">
                  <h4>Mobile App Developers</h4>
                  <ul>
                    <li>
                      <NavLink
                        to="/hire-flutter-developers"
                        lassName={
                          activeMenu === "/hire-flutter-developers"
                            ? "active-menu"
                            : ""
                        }
                      >
                        Flutter Developers
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        to="/hire-react-native-developers"
                        lassName={
                          activeMenu === "/hire-react-native-developers"
                            ? "active-menu"
                            : ""
                        }
                      >
                        React Native Developers
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        to="/hire-iphone-app-developer"
                        lassName={
                          activeMenu === "/hire-ios-app-developer"
                            ? "active-menu"
                            : ""
                        }
                      >
                        iOS Developers
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/hire-android-app-developer"
                        lassName={
                          activeMenu === "/hire-android-app-developer"
                            ? "active-menu"
                            : ""
                        }
                      >
                        Android Developers
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="main_menu_inner mega_menu_set">
                  <h4>Full Stack Developers</h4>
                  <ul>
                    <li>
                      <NavLink
                        to="/hire-mean-stack-developers"
                        lassName={
                          activeMenu === "/hire-mean-stack-developers"
                            ? "active-menu"
                            : ""
                        }
                      >
                        MeanStack Developers
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        to="/hire-php-developers"
                        lassName={
                          activeMenu === "/hire-php-developers"
                            ? "active-menu"
                            : ""
                        }
                      >
                        PHP Developers
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        to="/hire-python-developers"
                        lassName={
                          activeMenu === "/hire-python-developers"
                            ? "active-menu"
                            : ""
                        }
                      >
                        Python Developers
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        to="/hire-nodejs-developers"
                        lassName={
                          activeMenu === "/hire-nodejs-developers"
                            ? "active-menu"
                            : ""
                        }
                      >
                        Node.js Developers
                      </NavLink>{" "}
                    </li>
                  
                    <li>
                      <NavLink
                        to="/hire-vuejs-developer"
                        lassName={
                          activeMenu === "/hire-vuejs-developer"
                            ? "active-menu"
                            : ""
                        }
                      >
                        Vue Developers
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        to="/hire-reactjs-developers"
                        lassName={
                          activeMenu === "/hire-reactjs-developers"
                            ? "active-menu"
                            : ""
                        }
                      >
                        ReactJs Developers
                      </NavLink>{" "}
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="main_menu_inner mega_menu_set">
                  <h4>Functional Resources</h4>
                  <ul>
                    <li>
                      <NavLink
                        to="/business-analyst"
                        lassName={
                          activeMenu === "/Business-Aanalyst"
                            ? "active-menu"
                            : ""
                        }
                      >
                        Business Analyst
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/project-managers"
                        lassName={
                          activeMenu === "/Project-Managers"
                            ? "active-menu"
                            : ""
                        }
                      >
                        Project Managers
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        to="/software-testers"
                        lassName={
                          activeMenu === "/Software-Testers"
                            ? "active-menu"
                            : ""
                        }
                      >
                        Software Testers
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        to="/hire-designers"
                        lassName={
                          activeMenu === "/Hire-Designers" ? "active-menu" : ""
                        }
                      >
                        {" "}
                        Hire Designers
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="main_menu_inner">
                  <h4>Experts In</h4>
                  <ul>
                    <li>
                      <NavLink
                        to="/hire-ui-ux-developers"
                        lassName={
                          activeMenu === "/hire-ux-ui-developers"
                            ? "active-menu"
                            : ""
                        }
                      >
                        UI/UX Developer
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </ul>
      </li> */}
      {/* <li
        className={
          parentMenu === "about"
            ? "menu-item-has-children current-menu-item"
            : "menu-item-has-children"
        }
      >
        <Link to="" className={activeMenu === "" ? "active-menu" : ""}>
          Company
        </Link>
        <ul className="sub-menu submenu">
          <div className="border_menu ">
            <div className="row">
              <div className="col-lg-4">
                <div className="main_menu_inner mega_menu">
                  <h4>About Metaqualt</h4>
                  <ul>
                    <li>
                      <NavLink
                        to="/about-us"
                        lassName={
                          activeMenu === "/about-us" ? "active-menu" : ""
                        }
                      >
                        About us
                      </NavLink>{" "}
                    </li>

                    <li>
                      <NavLink
                        to="/client-testimonials"
                        lassName={
                          activeMenu === "/Client-Testimonials"
                            ? "active-menu"
                            : ""
                        }
                      >
                        Client Testimonials
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        to="/contact-us"
                        lassName={
                          activeMenu === "/Client-Testimonials"
                            ? "active-menu"
                            : ""
                        }
                      >
                        Contact Us
                      </NavLink>{" "}
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="main_menu_inner mega_menu">
                  <h4>Careers</h4>
                  <ul>
                    <li>
                      <NavLink
                        to="/current-openings"
                        lassName={
                          activeMenu === "/Current-Openings"
                            ? "active-menu"
                            : ""
                        }
                      >
                        Current Openings
                      </NavLink>{" "}
                    </li>

                    <li>
                      <NavLink
                        to="/life-at-metaqualt"
                        lassName={
                          activeMenu === "/Life-At-Metaqualt"
                            ? "active-menu"
                            : ""
                        }
                      >
                        Life At Metaqualt
                      </NavLink>{" "}
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="main_menu_inner">
                  <h4>Resources</h4>
                  <ul>
                    <li>
                      <NavLink
                        to="/blog"
                        lassName={activeMenu === "/blog" ? "active-menu" : ""}
                      >
                        Blog
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/white-paper"
                        lassName={
                          activeMenu === "/white-paper" ? "active-menu" : ""
                        }
                      >
                        White paper
                      </NavLink>{" "}
                    </li>
                    <li>
                          <NavLink
                            to="/case-study"
                            lassName={
                              activeMenu === "/case-study" ? "active-menu" : ""
                            }
                          >
                            Case Study
                          </NavLink>{" "}
                        </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </ul>
      </li> */}
      {/* <li className={parentMenu === "Portfolio" ? "current-menu-item" : ""}>
        <NavLink
          to="/portfolio"
          className={activeMenu === "/Portfolio" ? "active-menu" : ""}
        >
          Portfolio
        </NavLink>
      </li> */}
      <Link className="getTouch" to="/contact-us">
        Get In Touch
      </Link>
    </React.Fragment>
  );
};
export default MenuItems;
